import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "@/layout/Sidebar";
import TopNavbar from "@/layout/TopNavbar";
import SuperAdminBrand from "@/pages/SuperAdmin/SuperAdminBrand";
import SuperAdminClient from "@/pages/SuperAdmin/SuperAdminClient";
import SuperAdminAEClient from "@/pages/SuperAdmin/SuperAdminAEClient";
import SuperAdminUser from "@/pages/SuperAdmin/SuperAdminUser";
import SuperAdminContentIngestion from "@/pages/SuperAdmin/SuperAdminContentIngestion";
import SuperAdminQueryProcessing from "@/pages/SuperAdmin/SuperAdminQueryProcessing";
import Onboarding from "@/pages/SuperAdmin/Onboarding";
import { getLocalStorageWithExpiry } from "@/utils";
import "@/pages/page.css";

function SuperAdmin() {
  const { t } = useTranslation();
  const [isPermanentlyExpanded, setIsPermanentlyExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState("client"); // Add tab state

  const toggleSidebar = () => {
    setIsPermanentlyExpanded(!isPermanentlyExpanded);
  };

  const userRole = getLocalStorageWithExpiry("role");
  if (userRole !== "super-admin") {
    window.location.href = "/geo-dashboard";
  }

  return (
    <div className="app-container">
      <Sidebar
        currentPage={"Super-Admin"}
        isPermanentlyExpanded={isPermanentlyExpanded}
      />
      <main className="content bg-page">
        <div className="container-fluid p-4">
          <TopNavbar
            isPermanentlyExpanded={isPermanentlyExpanded}
            toggleSidebar={toggleSidebar}
          />
          <h3 className="h4 fw-bold text-dark">
            {t("superAdmin.title", "Super Admin Controls")}
          </h3>
          <p className="mt-1 fs-6 text-secondary">
            {t(
              "superAdmin.subtitle",
              "This is your Super Admin Controls Page. You can modify brands, client_config and users here.",
            )}
          </p>
          {/* Tab headers */}
          <ul className="nav nav-tabs mb-3" data-tour="super-admin.tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "client" ? "active" : ""}`}
                onClick={() => setActiveTab("client")}
              >
                {t("superAdmin.tabs.clientConfig", "Client Config")}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "ae-client" ? "active" : ""}`}
                onClick={() => setActiveTab("ae-client")}
              >
                {t("superAdmin.tabs.aeClientConfig", "AE Client Config")}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "brand" ? "active" : ""}`}
                onClick={() => setActiveTab("brand")}
              >
                {t("superAdmin.tabs.brands", "Brands")}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "user" ? "active" : ""}`}
                onClick={() => setActiveTab("user")}
                data-tour="super-admin.users"
              >
                {t("superAdmin.tabs.users", "Users")}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "content-ingestion" ? "active" : ""
                }`}
                onClick={() => setActiveTab("content-ingestion")}
              >
                {t("superAdmin.tabs.contentIngestion", "Content Ingestion")}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "query-processing" ? "active" : ""
                }`}
                onClick={() => setActiveTab("query-processing")}
              >
                {t("superAdmin.tabs.promptProcessing", "Prompt Processing")}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "onboarding" ? "active" : ""}`}
                onClick={() => setActiveTab("onboarding")}
                data-tour="super-admin.onboarding"
              >
                {t("superAdmin.tabs.onboarding", "Onboarding")}
              </button>
            </li>
          </ul>
          {/* Tab content */}
          <div data-tour="super-admin.content">
            {activeTab === "brand" && <SuperAdminBrand />}
            {activeTab === "client" && <SuperAdminClient />}
            {activeTab === "ae-client" && <SuperAdminAEClient />}
            {activeTab === "content-ingestion" && (
              <SuperAdminContentIngestion />
            )}
            {activeTab === "user" && <SuperAdminUser />}
            {activeTab === "query-processing" && <SuperAdminQueryProcessing />}
            {activeTab === "onboarding" && <Onboarding />}
          </div>
        </div>
      </main>
    </div>
  );
}

export default SuperAdmin;
